import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { Links } from "../../../../../Links";
import { GroupLinks } from "../../../../../GroupLinks";
import { MailInput } from "../../../../../MailInput";
import { AppButtonsDesktop } from "../../../../../AppButtonsDesktop";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var Block = /*#__PURE__*/memo(function (_ref) {
  var type = _ref.type,
    title = _ref.title,
    data = _ref.data;
  switch (type) {
    case 'links':
      return /*#__PURE__*/React.createElement(Links, {
        data: data,
        title: title
      });
    case 'groupLinks':
      return /*#__PURE__*/React.createElement(GroupLinks, {
        data: data
      });
    case 'subscribeMailingList':
      return /*#__PURE__*/React.createElement(MailInput, _extends({
        isVertical: true
      }, data));
    case 'beelineApps':
      return /*#__PURE__*/React.createElement("div", {
        className: cn('app-wrapper')
      }, /*#__PURE__*/React.createElement("div", {
        className: cn('app-wrapper__description')
      }, /*#__PURE__*/React.createElement(Text, {
        size: "size5-m"
      }, title)), /*#__PURE__*/React.createElement(AppButtonsDesktop, data));
    default:
      return null;
  }
});